import SiderLayout from "../../layouts/SiderLayout";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";
import { PrincipalSlider } from "../../pages/Principals/PrincipalSider/PrincipalSlider";

let childrenNormal = generateChildren([
  routes.principals().detailUsers,
  routes.principals().detail,
  routes.principals().detailInstitutions,
  routes.principals().detailUser(),
  routes.principals().addresses,
]);

export const principalRouter = [
  {
    path: routes.principals().path,
    handle: {
      crumb: e => routes.principals().ressourceCrumb(e),
    },
    element: (
      <SiderLayout>
        <PrincipalSlider></PrincipalSlider>
      </SiderLayout>
    ),
    children: [
      {
        path: routes.principals().detail.path,
        handle: {
          crumb: e => routes.principals().crumb(e),
        },
        children: childrenNormal,
      },
    ],
  },
];
